var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader"},[_c('h3',[_c('b-spinner',{staticClass:"mr-4"}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Please wait...")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }